let callCount = 0;

function offerTableAddOpen() {
    setTimeout(() => {

        const compTable = document.querySelectorAll(".compare-table");
        
        if(!compTable.length == 0) {
            compTable.forEach((table) => {
                const expander = table.querySelector(".expander");
                expander.addEventListener("click", () => {
                    expander.classList.toggle("open");
                    table.querySelectorAll(".add-feature").forEach((i) => {
                        i.classList.toggle("open");
                        i.classList.toggle("hidden");
                    })
                })
            })
        } else if (callCount<=5) {
            callCount++;
            offerTableAddOpen();
        } else {
            return;
        }
    }, 500)
}

export { offerTableAddOpen };